import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@fontsource/staatliches/400.css'
import '@fontsource-variable/league-spartan'
import './styles/fonts.css'
import './styles/tokens.css'
import './styles/app.css'
import { App } from './App'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
